import { Dispatch, SetStateAction } from "react"

import { PlayerError } from "../types"

export type VideoElementState = {
  isPlaying: boolean
  canPlay: boolean
  videoTimestamp: number
  isSeeking: boolean
  volume: number
  prevNonZeroVolume: number
  isMuted: boolean
}

export type VideoState = VideoElementState & {
  videoElement: HTMLVideoElement | null
  setVideoElement: Dispatch<SetStateAction<HTMLVideoElement | null>>
  subtitlesVisible: boolean
  setSubtitlesVisible: Dispatch<SetStateAction<boolean>>
  playerError: PlayerError | null
  setPlayerError: Dispatch<SetStateAction<PlayerError | null>>
  subtitleBottom: number
  setSubtitleBottom: Dispatch<SetStateAction<number>>
  setPrevNonZeroVolume: (volume: number) => void
  // We start by playing the video in a muted state, until the user clicks on the video.
  mutedPreview: boolean
  setMutedPreview: Dispatch<SetStateAction<boolean>>

  // Temporary: Eventually VideoContext should handle the video source setup itself, instead of consuming this
  setVideoSourceLoading: Dispatch<SetStateAction<boolean>>

  alreadyPlayed: boolean // whether the video has been played at least once. If not we show the BigPlayButton on shop-mini
}

export const defaultVideoElementState = {
  isPlaying: false,
  canPlay: false,
  videoTimestamp: 0,
  isSeeking: false,
  volume: 1,
  prevNonZeroVolume: 1,
  isMuted: false,
}

export const defaultVideoState: VideoState = {
  videoElement: null,
  setVideoElement: () => {},
  subtitlesVisible: false,
  setSubtitlesVisible: () => {},
  playerError: null,
  setPlayerError: () => {},
  subtitleBottom: 0,
  setSubtitleBottom: () => {},
  mutedPreview: true,
  setMutedPreview: () => {},

  setVideoSourceLoading: () => {},
  setPrevNonZeroVolume: () => {},

  alreadyPlayed: false,
  ...defaultVideoElementState,
}
